import {authHeaders, baseUrl, handleError, handleResponse} from "./apiUtils";

function getTeacher(id) {
  return fetch(`${baseUrl}teachers/${id}`, {
    headers: authHeaders(),
  })
    .then(handleResponse)
    .catch(handleError);
}

function getTeachers() {
  return fetch(`${baseUrl}teachers`, {
    headers: authHeaders(),
  })
    .then(handleResponse)
    .catch(handleError);
}

function saveTeacher(teacher) {
  return fetch(`${baseUrl}teachers/${teacher.id || ""}`, {
    method: teacher.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(teacher),
  })
    .then(handleResponse)
    .catch(handleError);
}


export default {
  getTeacher,
  getTeachers,
  saveTeacher,
};
